module.exports = "/_next/static/images/chris-lichti-ddcf71d63c5beb20ff29d6c6beb0ea13.jpg";